import { render, staticRenderFns } from "./Osa.vue?vue&type=template&id=2ceeb925&scoped=true&"
import script from "./Osa.vue?vue&type=script&lang=js&"
export * from "./Osa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceeb925",
  null
  
)

export default component.exports